export const ENV = {
  RTB_APP_URL: process.env.REACT_APP_RTB_APP_URL,
};
